var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6066 22.5147L13.0607 32.0607C12.4749 32.6464 11.5252 32.6465 10.9394 32.0607L1.39344 22.5147C0.807655 21.9289 0.807655 20.9792 1.39344 20.3934C1.97923 19.8076 2.92898 19.8076 3.51476 20.3934L10.5 27.3787L10.5 12H13.5L13.5 27.3787L20.4853 20.3934C21.0711 19.8076 22.0209 19.8076 22.6066 20.3934C23.1924 20.9792 23.1924 21.9289 22.6066 22.5147Z",
    fill: "#F1D9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8C14 9.10457 13.1046 10 12 10C10.8955 10 10 9.10457 10 8C10 6.89543 10.8955 6 12 6C13.1046 6 14 6.89543 14 8Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2C14 3.10457 13.1046 4 12 4C10.8955 4 10 3.10457 10 2C10 0.89543 10.8955 0 12 0C13.1046 0 14 0.89543 14 2Z",
    fill: "#D9D9D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileArrow);
export default __webpack_public_path__ + "static/media/mobile-arrow.6626c6a6d4456eb73fcf3441298f93ea.svg";
export { ForwardRef as ReactComponent };